import { REPORT_TEMPLATE, type IReportCardInfo, type MarketAnalysisCardData } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import _ from 'lodash'
import { I18nService } from '../i18n-service';

export const MarketAnalysisService = Symbol('MarketAnalysisService');

export type MarketAnalysisService = BaseCardService<MarketAnalysisCardData>

@injectable()
export class MarketAnalysisServiceImpl extends BaseCardServiceImpl<MarketAnalysisCardData> implements MarketAnalysisService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.MARKET_ANALYSIS;

    constructor(
        @inject(ReportApiService) _reportApiService: ReportApiService,
        @inject(I18nService) private readonly _i18nService: I18nService
    ) {
        super(
            _reportApiService
        );
    }

    private _generateObjectives(cardData: BaseReportCardData<IReportCardInfo>): MarketAnalysisCardData {
        return {
            description: cardData.data?.[REPORT_TEMPLATE.MARKET_ANALYSIS]?.OBJECTIVES_GPT.join() || this._i18nService.t('report.noData'),
        }
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')
        if (dataHaveFromUpdated) {
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data: this._generateObjectives(updatedValue),
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
